import StyledLink from '../../components/StyledLink';
import React from 'react';
import styled from 'styled-components/macro';

import { colors } from '../../styles/constants';
import { AccountAdminUser } from '../../types/management-auth';



const CreatedBy = (
    {
        createdBy,
        users,
    }: {
        createdBy: string | undefined;
        users?: AccountAdminUser[];
    }
) => {
    if (createdBy && createdBy.startsWith('mailto:')) {
        const mail = createdBy.replace('mailto:', '');
        return <StyledLink href={createdBy}>{mail}</StyledLink>;
    }
    const find = (users || []).find((user) => user.id === createdBy);
    if (find) {
        return <StyledLink href={`mailto:${find.email}`}>{find.email}</StyledLink>;
    }

    return <Code>{createdBy}</Code>;
};

const Code = styled.code`
    border: 1px solid transparent;

    &:hover {
                    background: ${colors.backgroundAlt};
        color: ${colors.invalid};
        border: 1px solid #ededed;
        border-radius: 2px;
    }
`;
export default CreatedBy;
